module.exports = __webpack_public_path__ + "static/media/logo.bdf3229f.png";